/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */

import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { TranslatorContext, useTranslator } from '@jutro/locale';
import metadata from './PolicyContactsAccordion.metadata.json5';
import styles from './PolicyContactsAccordion.module.scss'
import "@fortawesome/fontawesome-free/css/all.min.css"; 
import { Avatar, Icon } from '@jutro/components';
import { Flex, FlexItem, GridItem } from '@jutro/layout';

const PolicyContactsAccordion = props => {
    const {
        value: currentPeriodDetails
    } = props;
    let additionalInterestKey;
    let allPolicyContacts
    const translator = useTranslator();
     const viewModelService = useContext(ViewModelServiceContext);

    useEffect(() => {
        additionalInterestKey = getAdditionalInterestKey(currentPeriodDetails?.productCodeIdentifier_TWIA);
        allPolicyContacts = getAllPolicyContactDetails(currentPeriodDetails?.policyContactDetails_TWIA);
    })

    const getPrimaryPhoneType = (primaryPhoneType, policyContactDetail) => {
        switch (primaryPhoneType) {
            case 'home':
                return policyContactDetail?.homeNumber;
            case 'work':
                return policyContactDetail?.workNumber;
            case 'mobile':
                return policyContactDetail?.cellNumber;
            default:
                /**
                 * DE12266 - Contacts section UI issues
                 * When setting the PhoneNumber for AI, the PrimaryPhone is not being set. This is a fall-back to return the PhoneNumber if found without the PrimaryPhone Type.
                 */
                if (policyContactDetail?.workNumber) {
                    return policyContactDetail?.workNumber;
                } else if (policyContactDetail?.cellNumber) {
                    return policyContactDetail?.cellNumber;
                } else if (policyContactDetail?.homeNumber) {
                    return policyContactDetail?.homeNumber;
                }
                return null;
        }
    }

    const getAdditionalInterestKey = (productCode) => {
        if (productCode === 'Homeowners') {
            return 'additionalInterestDetails';
        } else if (productCode === 'CommercialProperty') {
            return 'cpAdditionalInterestDetails_TWIA';
        }
        return undefined;
    };

    const getAllPolicyContactDetails = (policyAdditionalInterestContacts) => {
        const policyContacts = _.map(policyAdditionalInterestContacts, getAdditionalInterestDetail(additionalInterestKey));
        return policyContacts;
    };

     const getStatus = useCallback((statusCode) => {
            const typelist = viewModelService?.productMetadata?.get('pc').types.getTypelist('AdditionalInterestType');
            const formattedTypes = typelist?.codes.map((code) => ({
                code: code.code,
                name: translator({ id: code.name })
            }));
    
            const matchingType = formattedTypes?.find((type) => type.code === statusCode);
    
            return matchingType ? matchingType.name : null;
        }, []);

    const getAdditionalInterestDetail = additionalInterestParentKey => policyContactDetail => {
        const allRoles = _.map(policyContactDetail?.policyContactRoles, 'subtype');
        const twiaContact = getPrimaryPhoneType(policyContactDetail?.primaryPhoneType, policyContactDetail);
        let ret = {
            allRoles,
            name: policyContactDetail.displayName,
            phone: twiaContact,
            mailingAddress: policyContactDetail.primaryAddress.displayName,
            subtype: policyContactDetail.subtype
        };

        const roleWithAdditionalInterest = _.find(policyContactDetail.policyContactRoles, (r) => {
            const { policyAdditionalInterest: { [additionalInterestParentKey]: [found = undefined] = [] } = {} } = r;
            return found !== undefined;
        });
        const { policyAdditionalInterest: { [additionalInterestParentKey]: [firstAdditionalInterestDetail = undefined] = [] } = {} } = { ...roleWithAdditionalInterest };
        if (firstAdditionalInterestDetail) {
            const aiDetail = {
                interestType: getStatus(firstAdditionalInterestDetail.type),
                loanNumber: firstAdditionalInterestDetail.contractNumber,
            };
            ret = { ...ret, aiDetail };
            return ret;
        }
        return ret;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const policyContactRoles = useCallback((policyContactRole) => {
        const result = []
        let ret
        policyContactRole.map((role) => {
            switch (role) {
                case 'PolicyPriNamedInsured':
                    ret = 'Primary Named Insured';
                    break;
                case 'PolicyAddlNamedInsured':
                    ret = 'Additional Named Insured';
                    break;
                case 'PolicyAddlInterest':
                    ret = 'Additional Interest';
                    break;
                default:
                    ret = role;
            }
            result.push(ret)
        })
        return result.join(" , ")

    })

    const generateOverrides = useCallback(() => {
        if (!_.isUndefined(allPolicyContacts)) {
            const overrides = allPolicyContacts.map((item, index) => {
                return {
                    [`contactsValue${index}`]: {
                        content: <div>
                            <div className={styles.container}>

                                <div key={index} className={styles.row}>

                                    <div className={styles.column}>
                                        {item.subtype !== "Person" ? (
                                            <GridItem>
                                                <Flex gap="small">
                                                    <FlexItem className={styles.iconStyle} >
                                                    <i className="fa fa-building" aria-hidden="true"></i>
                                                    </FlexItem>
                                                    <FlexItem className={styles.name}>
                                                        {item.name}
                                                    </FlexItem>
                                                </Flex>
                                            </GridItem>
                                        ) : (
                                            <GridItem>
                                                <Flex gap="small">
                                                    <FlexItem className={styles.iconStyle}>
                                                    <i className="fa fa-male" aria-hidden="true"></i>
                                                    </FlexItem>
                                                    <FlexItem className={styles.name}>
                                                        {item.name}
                                                    </FlexItem>
                                                </Flex>
                                            </GridItem>
                                        )}

                                    </div>
                                    <div className={styles.column}>
                                        <span className={styles.value}>{policyContactRoles(item.allRoles)}</span>
                                    </div>
                                    {item.aiDetail ? (
                                        <div className={styles.column}>
                                            <span className={styles.label}>Interest Type</span>
                                            <br />
                                            <span className={styles.value}>{item.aiDetail.interestType}</span>
                                            <br />
                                            <span className={styles.label}>Loan Number</span>
                                            <br />
                                            <span className={styles.value}>{item.aiDetail.loanNumber}</span>
                                        </div>
                                    ) : <div></div>}

                                    <div className={styles.column}>
                                        <span className={styles.label}>Phone</span>
                                        <br />
                                        <span className={styles.value}>{item.phone}</span>
                                        <br />
                                        <span className={styles.label}>Mailing Address</span>
                                        <br />
                                        <span className={styles.value}>{item.mailingAddress}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    },
                };
            });

            return Object.assign({}, ...overrides);
        }

    }, [currentPeriodDetails]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            className: styles.fieldStyle
        },
        contactsSection: {
            data: _.get(currentPeriodDetails, 'policyContactDetails_TWIA')
        },
        ...generateOverrides()
    };


    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {

        }
    };


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={currentPeriodDetails}
            classNameMap={resolvers.resolveClassNameMap}
        // componentMap={resolvers.resolveComponentMap}
        />
    );
};


PolicyContactsAccordion.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    //authHeader: PropTypes.shape({}).isRequired,
};
export default PolicyContactsAccordion;
